var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('labelc',{staticClass:"day",class:{
    selected:
      _vm.dateSelected &&
      _vm.dateSelected.format('YYYY-MM-DD') === _vm.date.format('YYYY-MM-DD'),
  },style:({
    'margin-left': (_vm.date.isoWeekday() - 1) * 30 + 'px',
    clear: _vm.date.isoWeekday() === 7 ? 'both' : '',
  }),attrs:{"text":_vm.date.format('D')},on:{"click":_vm.Click}})}
var staticRenderFns = []

export { render, staticRenderFns }